// Single source of truth for flower weight pricing (mirrors backend FLOWER_TIERS).
export const FLOWER_TIERS = {
  Bronze: {
    "$5/g": { "1G": 5, "4G": 15, "8G": 30, "16G": 55, "28G": 75 },
    "$6/g": { "1G": 6, "4G": 20, "8G": 40, "16G": 75, "28G": 100 },
    "$8/g": { "1G": 8, "4G": 25, "8G": 47, "16G": 85, "28G": 125 },
  },
  Silver: {
    "$10/g": { "1G": 10, "4G": 30, "8G": 55, "16G": 100, "28G": 155 },
    "$12/g": { "1G": 12, "4G": 40, "8G": 70, "16G": 135, "28G": 200 },
  },
  Platinum: { "$13/g": { "1G": 13, "4G": 45, "8G": 80, "16G": 135, "28G": 225 } },
  Champions: { "$15/g": { "1G": 15, "4G": 50, "8G": 90, "16G": 145, "28G": 225 } },
};

export const FLOWER_WEIGHTS = ["1G", "4G", "8G", "16G", "28G"];
export const WEIGHT_GRAMS = { "1G": 1, "4G": 4, "8G": 8, "16G": 16, "28G": 28 };
export const TIER_NAMES = ["Bronze", "Silver", "Platinum", "Champions"];
export const TIER_COLORS = {
  Bronze: "from-amber-600 to-amber-800",
  Silver: "from-slate-400 to-slate-600",
  Platinum: "from-cyan-500 to-blue-600",
  Champions: "from-fuchsia-600 to-purple-700",
};
